<div class="modal-overlay" *ngIf="isOpen" (click)="onOverlayClick($event)">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="modal-header">
      <h2 class="modal-title">Replace Current Template?</h2>
      <button class="modal-close" (click)="onClose()" [disabled]="isLoading">
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 1L11 11M11 1L1 11" stroke="#15172E" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
      </button>
    </div>

    <!-- Main Content -->
    <div class="modal-body">
      <p class="warning-intro">If you replace your current template, the following will be lost:</p>
      
      <ul class="warning-list">
        <li>Layout and page design will reset to the new template.</li>
        <li>Your text and images won't adapt into the new layout.</li>
        <li>Page structure adjustments may not carry over.</li>
      </ul>

      <!-- Info Box -->
      <div class="info-box">
        <div class="info-icon">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="1.5"/>
            <path d="M8 7V11M8 5V5.01" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
        </div>
        <div class="info-text">
          <strong>Switch to a new template</strong> Your logo, colors, and fonts will auto-apply to the new template.
        </div>
      </div>
    </div>

    <!-- Footer Actions -->
    <div class="modal-footer">
      <button class="btn-cancel" (click)="onClose()" [disabled]="isLoading">Cancel</button>
      <button class="btn-confirm" (click)="onConfirm()" [disabled]="isLoading">
        <span *ngIf="!isLoading">Replace Template</span>
        <span *ngIf="isLoading" class="button-loader">
          <svg class="spinner" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="2" stroke-opacity="0.3"/>
            <path d="M8 1A7 7 0 0 1 15 8" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
          Replacing...
        </span>
      </button>
    </div>
  </div>
</div>

